






























import Vue from 'vue'

export default Vue.extend({
  $_veeValidate: {
    value() {
      return this.value;
    },
    name() {
      return this.name;
    }
  },
  props: {
    value: {
      type:String,
      default:''
    },
    label: {
      type:String
    },
    id: {
      type:String,
    },
    placeholder: {
      type:String,
      default:''
    },
    name: {
      type:String,
      default:''
    },
    type: {
      type:String,
      default:'text'
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: ''
    },
    rows:{
      type: [String,Number],
      default:4
    },
    disabled: {
      type: [Boolean, String]
    },
    maxlength: {
      type: String,
      default: ''
    },
    expandable: {
      type: Boolean,
      default: true
    }
  }
})
